import React from "react";
import Page from "../../../components/Page";
import WorkshopDetailComp from "../../../components/NewDesign/Event/WorkshopDetailComp";

const WorkshopDetailPage = () => {
  return (
    <>
      <Page>
        <WorkshopDetailComp />
      </Page>
    </>
  );
};

export default WorkshopDetailPage;
